module.exports = __webpack_public_path__ + "7f3244f64e6bd9da38572713ff4151dc.png";